import API from './fetchAPI'

export const fetchDashboardStats = async () => {
    try {
        const response = await API.get('/api/dashboard/stats')
        return response
    } catch (error) {
        console.error('Error fetching dashboard stats:', error)
        throw error
    }
}